export enum LegalInfo {
  LICENCE_CONDITION = 'legal_licenceCondition'
}
